import { firestore, collection, query, where, getDocs } from "../firebase/firebaseConfig";

/**
 * Generates a unique random username.
 * @returns {Promise<string>} A unique randomly generated username.
 */
export const generateRandomUsername = async () => {
  const adjectives = [
    "Brave", "Swift", "Clever", "Bold", "Mighty", "Lucky", "Fierce", "Gentle", "Noble", "Sharp",
    "Wise", "Rapid", "Fearless", "Loyal", "Witty", "Energetic", "Epic", "Cool", "Dynamic", "Heroic",
    "Legendary", "Majestic", "Radiant", "Thunderous", "Unstoppable", "Vibrant", "Zealous", "Charming",
    "Graceful", "Magnetic", "Playful", "Dashing", "Adventurous", "Brilliant", "Diligent", "Jolly",
    "Resilient", "Sincere", "Valiant", "Eager", "Gallant", "Mysterious", "Inventive", "Fearsome",
    "Quick", "Trustworthy", "Whimsical", "Ambitious", "Creative", "Resourceful", "Humble", "Determined",
    "Exuberant", "Radiant", "Daring", "Tenacious", "Spirited", "Perseverant"
  ];

  const nouns = [
    "Falcon", "Lion", "Tiger", "Eagle", "Panda", "Fox", "Wolf", "Hawk", "Bear", "Dragon",
    "Cheetah", "Phoenix", "Otter", "Stag", "Raven", "Panther", "Viper", "Gorilla", "Jaguar", "Lynx",
    "Shark", "Zebra", "Puma", "Orca", "Leopard", "Rhino", "Condor", "Armadillo", "Bison", "Lizard",
    "Koala", "Owl", "Salmon", "Wolverine", "Pelican", "Cobra", "Gazelle", "Dolphin", "Camel", "Bobcat",
    "Meerkat", "Antelope", "Seahorse", "Otter", "Jackal", "Raccoon", "Kingfisher", "Heron", "Chameleon",
    "Beetle", "Alpaca", "Peacock", "Hedgehog", "Mongoose", "Walrus", "Llama", "Caterpillar", "Crane"
  ];

  let username;
  let isUnique = false;

  const isUsernameUnique = async (name) => {
    const usersRef = collection(firestore, "users");
    const q = query(usersRef, where("userName", "==", name));
    const snapshot = await getDocs(q);
    return snapshot.empty; // If no match found, username is unique
  };

  while (!isUnique) {
    const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Generates a unique 4-digit number
    username = `${randomAdjective}${randomNoun}${randomNumber}`;

    isUnique = await isUsernameUnique(username);
  }

  console.log(`Generated unique username: ${username}`);
  return username;
};
